import { NgModule } from '@angular/core';
import { BaseProfilePageComponent} from "./base-profile-page.component";
import {MatInputModule} from "@angular/material/input";
import {ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {Home365LoaderModule} from "../loader/home365-loader.module";
import {MatIconModule} from "@angular/material/icon";
import {CommonModule} from "@angular/common";
import {MatDatepickerModule} from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

@NgModule({
  declarations: [BaseProfilePageComponent],
  exports: [BaseProfilePageComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatInputModule,
    MatButtonModule,
    Home365LoaderModule,
    MatIconModule,
    MatDatepickerModule,
    MatMomentDateModule,
  ],
  providers: [{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }]
})
export class BaseProfilePageModule { }
